export default __webpack_public_path__ + "static/media/miguel-lopes-44.d56a2c84.jpg";